import type { ApiRelationship, ApiTypeIdentifier } from '@app/packages/api/v2/types/lib'

export const getRelationshipValue = <T>(val: ApiRelationship<T>) => {
  if (val.meta && !val.meta.included) throw new Error('Relationship value is not included in the response')
  return val.data as ApiTypeIdentifier<T>
}
